module.exports = __webpack_public_path__ + "img/74-r.57f2b3f3.png";